module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b-field-view"
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n\n      " + _vm._s(_vm.field.title) + "\n\n    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(_vm.isEncrypted) ? _c('div', [_c('crypt-value', {
    attrs: {
      "value": _vm.value
    }
  })], 1) : _c('div', [(_vm.field.fieldType === 'uploader') ? _c('div', _vm._l((_vm.value), function(file, n) {
    return _c('div', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.apiUrl + '/v1/attachments/' + file._id
      }
    }, [_vm._v("File " + _vm._s(n + 1))])])
  }), 0) : (_vm.field.fieldType === 'radio') ? _c('div', [_c('i', {
    staticClass: "fa fa-dot-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.value) + "\n        ")]) : (_vm.field.fieldType === 'checkbox') ? _c('div', _vm._l((_vm.value), function(val) {
    return _c('div', [_c('i', {
      staticClass: "fa fa-check-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(val) + "\n          ")])
  }), 0) : _c('div', [_vm._v("\n          " + _vm._s(_vm.value) + "\n        ")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0474834a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/fieldView.vue
// module id = 356
// module chunks = 4